"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartEntity = void 0;
/**
 * @public
 * {@inheritDoc IChartEntity}
 */
class ChartEntity {
    constructor(identifierFactory) {
        this.identifierFactory = identifierFactory;
        this.isFiltered = false;
        this.changeId = this.identifierFactory.getNextId();
    }
    onBeforeUpdate() {
        // no action
    }
    updateChangeId() {
        this.changeId = this.identifierFactory.getNextId();
    }
}
exports.ChartEntity = ChartEntity;
//# sourceMappingURL=chart-entity.js.map